<template>
    <div class="cz2__camera-access-wrapper">
        <div
            v-if="accessState === 'denied'"
            class="cz2__camera-access"
        >
            <h1
                v-html="$t('AI_SELFIE_OH_NO')"
                class="cz2__modal-popup__header"
            />

            <p class="cz2__selfie-steps">
                {{ $t('AI_SELFIE_STEPS_INTRO') }}
            </p>

            <ul
                v-html="stepsList"
                class="cz2__modal-popup__copy cz2__selfie-steps-list"
            />

            <btn
                primary
                @click="showDefaultScreen"
            >
                {{ $t('AI_RELOAD') }}
            </btn>
        </div>

        <div v-else-if="accessState !== 'loading'">
            <div class="cz2__modal-popup__header">
                {{ $t('AI_SELFIE_ALLOW') }}
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz2__ai-modal {
            .cz2__camera-access-wrapper {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                padding: 8px;
            }

            .cz2__camera-access {
                max-width: 600px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .cz2__selfie-steps {
                    margin-top: 16px;
                    font-size: 22px;
                    font-family: var(--cz-font-500-family);
                    font-weight: var(--cz-font-500-weight);
                }

                .cz2__selfie-steps-list {
                    margin-left: 32px;
                    display: flex;
                    flex-direction: column;
                    gap: 24px;
                    font-size: 16px;
                    text-align: left;
                    list-style: disc;
                }

                .cz2__btn--primary {
                    margin-top: 24px;
                }
            }
        }
    }
</style>

<script>
    import Btn from '../ui/Btn.vue';

    export default {
        components: {
            Btn,
        },

        props: {
            accessState: {
                type: String,
                default: 'loading',
            },
        },

        data() {
            return {
                stepsList: null,
            };
        },

        computed: {
            aiStates() {
                return this.$store.state.aiStates;
            },
        },

        created() {
            this.getBrowserSteps();
        },

        methods: {
            showDefaultScreen() {
                this.$store.dispatch('setAiActiveState', this.aiStates.default);
            },

            async getBrowserSteps() {
                // Prefer modern User-Agent Client Hints
                if (navigator.userAgentData) {
                    const brands = navigator.userAgentData.brands || [];
                    const brandNames = brands.map((b) => b.brand.toLowerCase());
                    const ua = navigator.userAgent;

                    // Brave (feature-based detection only)
                    if (navigator.brave && await navigator.brave.isBrave()) {
                        this.stepsList = this.$t('AI_SELFIE_BRAVE_STEPS');
                        return 'Brave';
                    }

                    // Chromium-based browsers via brand hints
                    if (brandNames.some((b) => b.includes('edge'))) {
                        this.stepsList = this.$t('AI_SELFIE_EDGE_STEPS');
                        return 'Microsoft Edge';
                    }
                    if (brandNames.some((b) => b.includes('opera')) || /OPR\//.test(ua)) {
                        this.stepsList = this.$t('AI_SELFIE_OPERA_STEPS');
                        return 'Opera';
                    }
                    if (brandNames.some((b) => b.includes('yandex')) || /YaBrowser/.test(ua)) {
                        this.stepsList = this.$t('AI_SELFIE_YANDEX_STEPS');
                        return 'Yandex Browser';
                    }
                    if (brandNames.some((b) => b.includes('samsung')) || /SamsungBrowser/.test(ua)) {
                        this.stepsList = this.$t('AI_SELFIE_SAMSUNG_STEPS');
                        return 'Samsung Internet';
                    }

                    // Chrome (exclude known Chromium variants)
                    if (brandNames.some((b) => b.includes('google chrome')) || brandNames.some((b) => b.includes('chromium'))) {
                        this.stepsList = this.$t('AI_SELFIE_STEPS');
                        return 'Chrome';
                    }

                    // Unknown Chromium derivative
                    this.stepsList = this.$t('AI_SELFIE_STEPS');
                    return 'Chromium-based (unknown)';
                }

                // Fallback for non-Client-Hints browsers
                const ua = navigator.userAgent;

                if (/Firefox\//.test(ua)) {
                    this.stepsList = this.$t('AI_SELFIE_FF_STEPS');
                    return 'Firefox';
                }
                if (/Silk\//.test(ua)) {
                    this.stepsList = this.$t('AI_SELFIE_SILK_STEPS');
                    return 'Amazon Silk';
                }

                // Safari detection (no vendor usage)
                // Safari's UA typically includes 'Safari' but not 'Chrome' or 'Chromium'
                if (/Safari\//.test(ua) && !/Chrome|Chromium|Edg|OPR|YaBrowser|Silk/.test(ua)) {
                    this.stepsList = this.$t('AI_SELFIE_SAFARI_STEPS');
                    return 'Safari';
                }

                this.stepsList = this.$t('AI_SELFIE_STEPS');
                return 'Unknown';
            },
        },
    };
</script>
